import React from "react";
import TypingEffect from "./TypingEffect";
import styles from "./VideoComponent.module.css";

function VideoComponent() {
  // HomePage0 (7).jpg
  return (
    <>
      <div className={styles.homeHeader}>
        <div className={styles.imageContainer}>
          <img
            src={process.env.PUBLIC_URL + "/image/HomePage0(13).avif"}
            alt="רקע"
            className={styles.image}
          />
        </div>
        <div className={styles.textContainer}>
          <h1 className={styles.title}>
            פי<u className="n-color-title-home-page">נתי</u>
          </h1>
          <h2 className={styles.typingText}>
            <TypingEffect text="פינת הקוד של נתי" />
          </h2>
        </div>
      </div>
    </>
  );
}

export default VideoComponent;
